.ux-scroll-to-top-button {
  display: inline-block;
  min-height: 44px;
  min-width: 44px;
  padding: 9px 12px 7px;

  .ux-icon {
    font-size: 18px;
  }

  &:hover {
    svg {
      fill: $color-white;
    }
  }
}

.ux-scroll-to-top-button.ux-scroll-to-top-button--square {
  padding: 12px;
}
